/**
 * Props for the Tooltip component.
 */

import { ReactElement, ReactNode } from 'react';

import { CssClass } from '../styled';

interface BaseTooltipProps {
  title: string | ReactNode;
  arrow?: boolean;
  type?: 'click' | 'hover';
  children: ReactElement<any, any>;
  className?: string;
  /**
   * Tooltip placement.
   * @default 'top'
   */
  placement?:
    | 'bottom-end'
    | 'bottom-start'
    | 'bottom'
    | 'left-end'
    | 'left-start'
    | 'left'
    | 'right-end'
    | 'right-start'
    | 'right'
    | 'top-end'
    | 'top-start'
    | 'top';
}

interface TooltipPropsClickType extends BaseTooltipProps {
  type?: 'click';
  open?: boolean;
  onClose?: () => void;
}

interface TooltipPropsHoverType extends BaseTooltipProps {
  type?: 'hover';
}

export type TooltipProps = TooltipPropsClickType | TooltipPropsHoverType;

export const TooltipClasses = {
  arrow: new CssClass('tooltip-arrow'),
  tooltip: new CssClass('tooltip-tooltip'),
} as const;
